import React from 'react'
import PropTypes from 'prop-types'
import LocationStore from 'stores/locationStore'
import SidebarStateStore from 'stores/sidebarStateStore'
import Utils from 'common/utils'
import 'styles/weather-view.css'

export default class SidebarBurger extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isSidebarOpen: SidebarStateStore.getIsSidebarOpen(),
            geoLocation: LocationStore.getGeoLocationFromStore(),
            newLocationsCount: 0,
        }

        this.__locStoreListener = LocationStore.registerCbForNewGeoLocation(this.geoLocationListener.bind(this))
        this.__sidebarListener = SidebarStateStore.registerForStateChange(this.sidebarListeners.bind(this))
    }

    render() {
        return (
            <div
                className="threebars-wrap"
                onClick={() => {
                    this.props.on_click_cb()
                }}
            >
                <div className="threebars-content-wrapper">
                    <img src="/image/threebars.svg" alt="breadcrum_icon" />
                    {this.selectivelyDisplayLocationNotifier()}
                </div>
            </div>
        )
    }

    componentWillUnmount() {
        if (false === Utils.isNull(this.__sidebarListener)) {
            SidebarStateStore.unregisterListenerForKey(this.__sidebarListener)
        }
        if (false === Utils.isNull(this.__locStoreListener)) {
            LocationStore.unregisterCbNewGeoLocationForKey(this.__locStoreListener)
        }
    }

    geoLocationListener() {
        let newLoc = LocationStore.getGeoLocationFromStore()
        if (Utils.isNull(newLoc)) {
            return
        }

        // This needs to be partially equal (If lat-lon is different, but place is the same, then it should return true)
        if (true === newLoc.areWeatherAreasEqual(this.state.geoLocation)) {
            console.log("Not updating the geo-location since the values equal")
            return
        }

        this.setState({
            geoLocation: LocationStore.getGeoLocationFromStore(),
            newLocationsCount: (this.state.newLocationsCount + 1),
        })
    }

    sidebarListeners() {
        // Everytime the side-bar is open or closed, then reset the count automatically. 
        // This handles all the cases (click and drag-opening a sidebar!)
        this.resetLocationsCount()

        this.setState({
            isSidebarOpen: SidebarStateStore.getIsSidebarOpen()
        })
    }

    resetLocationsCount() {
        this.setState({
            newLocationsCount: 0,
        })
    }

    selectivelyDisplayLocationNotifier() {
        // Add logic to display the update selectively
        if (
            this.state.newLocationsCount > 0 &&
            this.state.isSidebarOpen === false &&
            false === LocationStore.isCurrentLocationFromGeo()
        ) {
            return (
                <div className="location-update-notifier"></div>
            )
        }
        return (<span></span>)
    }
}

SidebarBurger.propTypes = {
    on_click_cb: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/weather/sidebarBurger.js